module.exports = __webpack_public_path__ + "img/page.5ca71736.png";